import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';

interface MobileSegmentedControlProps {
  tabs: string[];
  selectedIndex: number;
  onTabChange: (index: number) => void;
}

export const MobileSegmentedControl: React.FC<MobileSegmentedControlProps> = ({
  tabs,
  selectedIndex,
  onTabChange,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.segmentedControl}>
        {tabs.map((tab, index) => {
          const isSelected = selectedIndex === index;
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;
          
          return (
            <TouchableOpacity
              key={index}
              style={[
                styles.tabButton,
                isSelected && styles.selectedTabButton,
                isFirst && styles.firstTabButton,
                isLast && styles.lastTabButton,
              ]}
              onPress={() => onTabChange(index)}
              accessibilityRole="tab"
              accessibilityState={{ selected: isSelected }}
              accessibilityLabel={tab}
            >
              <Text style={[
                styles.tabButtonText,
                isSelected && styles.selectedTabButtonText,
              ]}>
                {tab}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY,
  },
  segmentedControl: {
    flexDirection: 'row',
    backgroundColor: '#E5E5EA',
    borderRadius: 9,
    padding: 2,
  },
  tabButton: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 7,
  },
  selectedTabButton: {
    backgroundColor: RESIDENTS_MOBILE_COLORS.TEXT_SECONDARY,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
    elevation: 2,
  },
  firstTabButton: {
    marginRight: 1,
  },
  lastTabButton: {
    marginLeft: 1,
  },
  tabButtonText: {
    fontSize: 13,
    fontWeight: '400',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
  },
  selectedTabButtonText: {
    fontWeight: '600',
  },
});

